<template>
  <div class="container">
    <Menu />

    <div id="capnhat-page">
      <div class="is-flex is-justify-between cn-dau">
        <h1 class="title is-5">{{ lang('Tìm bản mới') }}</h1>
        <button class="button is-small" :class="{ 'is-loading': dangKiemTra }" :disabled="dangKiemTra" @click="kiemTraTatCa">
          <b-icon icon="sync-alt" size="is-small" /> <span>{{ lang('Kiểm tra ngay') }}</span>
        </button>
      </div>

      <div v-if="github && !github.co_token && github.hop_le && github.con_lai <= 15" class="notification is-warning is-light cn-gh-canh">
        {{ lang('GitHub chỉ còn') }} <b>{{ github.con_lai }}</b> {{ lang('lượt tra cứu trong giờ này (không có token nên giới hạn 60 lượt/giờ). Thêm token ở tab Cài đặt để nâng lên 5000 lượt/giờ.') }}
        <a @click="tab = 3; doiTab(3)">{{ lang('Mở Cài đặt') }}</a>
      </div>

      <ChoXuLy :dang="dangKiemTra" :uoc-tinh="Math.max(8, quyTac.length * 3)" :nhan="lang('Đang kiểm tra bản mới của') + ' ' + quyTac.length + ' ' + lang('phần mềm...')" />

      <div v-if="soMoi" class="notification is-info is-light">
        {{ lang('Có') }} {{ soMoi }} {{ lang('phần mềm có bản mới') }}
      </div>

      <b-tabs v-model="tab" :animated="false" @input="doiTab">
        <b-tab-item :label="lang('Đang theo dõi') + ' (' + quyTac.length + ')'">
          <b-table :data="quyTacSapXep" :hoverable="true" :mobile-cards="false">
            <template slot-scope="props">
              <b-table-column :label="lang('Phần mềm')">
                <div class="cn-ten">{{ props.row.ung_dung }}</div>
                <div class="cn-phu">{{ props.row.duong_dan }}</div>
              </b-table-column>
              <b-table-column :label="lang('Đang dùng')">{{ props.row.phien_ban }}</b-table-column>
              <b-table-column :label="lang('Mới nhất')"><b>{{ props.row.moi_nhat || '-' }}</b></b-table-column>
              <b-table-column :label="lang('Trạng thái')">
                <b-tag :type="tag(props.row).loai" :title="props.row.tai && props.row.tai.loi ? props.row.tai.loi : (props.row.loi_kiem_tra || '')">
                  {{ tag(props.row).nhan }}
                </b-tag>
              </b-table-column>
              <b-table-column :label="lang('Cách tải')">{{ props.row.che_do === 'tu_dong' ? lang('Tự động') : lang('Thủ công') }}</b-table-column>
              <b-table-column :label="lang('Bản cũ')">{{ props.row.giu_cu ? lang('Giữ') : lang('Vào thùng rác') }}</b-table-column>
              <b-table-column>
                <div class="cn-hanhdong">
                  <button v-if="props.row.trang_thai == 'moi'" class="button is-small is-primary" @click="taiBanMoi(props.row)">
                    {{ lang('Tải') }}
                  </button>
                  <button class="button is-small" @click="sua(props.row)">{{ lang('Sửa') }}</button>
                  <button class="button is-small" @click="huy(props.row)">{{ lang('Hủy theo dõi') }}</button>
                </div>
              </b-table-column>
            </template>
            <template slot="empty">
              <p class="cn-rong">{{ lang('Chưa theo dõi phần mềm nào. Mở thư mục chứa file .exe ở tab Tệp, bấm "..." ở file rồi chọn "Theo dõi bản mới".') }}</p>
            </template>
          </b-table>
          <p class="help cn-ghichu">
            {{ lang('Chỉ nhận diện được tệp .exe. Phần mềm không có link tải công khai (cần đăng nhập, giấy phép...) thì không tải tự động được.') }}
          </p>
        </b-tab-item>

        <b-tab-item :label="lang('Lịch sử')">
          <div class="is-flex cn-loc">
            <b-select v-model="locApp" size="is-small" @input="taiLichSu">
              <option value="">{{ lang('Tất cả phần mềm') }}</option>
              <option v-for="a in dsApp" :key="a" :value="a">{{ a }}</option>
            </b-select>
            <b-checkbox v-model="chiLoi" @input="taiLichSu">{{ lang('Chỉ lỗi') }}</b-checkbox>
          </div>
          <b-table :data="lichSu" :hoverable="true" :mobile-cards="false">
            <template slot-scope="props">
              <b-table-column :label="lang('Thời gian')" width="170">{{ formatDate(props.row.t) }}</b-table-column>
              <b-table-column :label="lang('Phần mềm')"><b>{{ props.row.app }}</b></b-table-column>
              <b-table-column :label="lang('Sự kiện')">{{ props.row.ev }}</b-table-column>
              <b-table-column :label="lang('Chi tiết')"><span class="cn-chitiet">{{ props.row.d }}</span></b-table-column>
              <b-table-column :label="lang('Kết quả')">
                <b-tag :type="loaiTag(props.row.k)">{{ props.row.r }}</b-tag>
              </b-table-column>
            </template>
            <template slot="empty">
              <p class="cn-rong">{{ lang('Chưa có sự kiện nào.') }}</p>
            </template>
          </b-table>
          <p class="help cn-ghichu">{{ lang('Lịch sử được lưu 12 tháng, các dòng cũ hơn tự động dọn.') }}</p>
        </b-tab-item>

        <b-tab-item :label="lang('Thùng rác') + ' (' + thungRac.length + ')'">
          <div v-if="thungRac.length" class="cn-rac-nut">
            <button class="button is-small is-danger is-outlined" :disabled="!chonRac.length || dangXoa" @click="xoaDaChon">
              <b-icon icon="trash-alt" size="is-small" /> <span>{{ lang('Xóa đã chọn') }} ({{ chonRac.length }})</span>
            </button>
            <button class="button is-small is-danger" :disabled="dangXoa" @click="xoaToanBo">
              <b-icon icon="trash" size="is-small" /> <span>{{ lang('Xóa toàn bộ') }} ({{ thungRac.length }})</span>
            </button>
            <span class="cn-phu">{{ lang('Tổng dung lượng') }}: {{ formatBytes(tongRac) }}</span>
          </div>
          <b-table :data="thungRac" :checked-rows.sync="chonRac" checkable :hoverable="true" :mobile-cards="false">
            <template slot-scope="props">
              <b-table-column :label="lang('Tệp')"><b>{{ props.row.ten }}</b></b-table-column>
              <b-table-column :label="lang('Phần mềm')">{{ props.row.ung_dung }}</b-table-column>
              <b-table-column :label="lang('Dung lượng')">{{ formatBytes(props.row.dung_luong || 0) }}</b-table-column>
              <b-table-column :label="lang('Vào thùng lúc')">{{ formatDate(props.row.luc) }}</b-table-column>
              <b-table-column :label="lang('Tự xóa hẳn sau')">{{ lang('Còn') }} {{ props.row.con_lai_ngay }} {{ lang('ngày') }}</b-table-column>
              <b-table-column>
                <div class="cn-hanhdong">
                  <button class="button is-small" @click="khoiPhuc(props.row)">{{ lang('Khôi phục') }}</button>
                  <button class="button is-small is-danger is-outlined" @click="xoaHan(props.row)">{{ lang('Xóa hẳn') }}</button>
                </div>
              </b-table-column>
            </template>
            <template slot="empty">
              <p class="cn-rong">{{ lang('Thùng rác trống.') }}</p>
            </template>
          </b-table>
          <p class="help cn-ghichu">{{ lang('Chỉ chứa bản cũ bị thay thế khi không tick "Giữ bản cũ".') }}</p>
        </b-tab-item>

        <b-tab-item :label="lang('Cài đặt')">
          <div class="cn-cd">
            <h2 class="cn-cd-tieu">{{ lang('Token GitHub') }} <span class="cn-phu">({{ lang('không bắt buộc') }})</span></h2>
            <p class="cn-phu">{{ lang('Phần mềm tra bản mới qua GitHub. Không có token thì GitHub chỉ cho 60 lượt/giờ cho cả máy chủ; có token là 5000 lượt/giờ. Token chỉ cần quyền đọc kho công khai, không cấp thêm quyền nào.') }}</p>

            <div v-if="!github" class="cn-phu">{{ lang('Đang kiểm tra...') }}</div>
            <div v-else class="cn-gh-tt">
              <b-tag v-if="github.co_token && github.hop_le" type="is-success">{{ lang('Đang dùng token') }} …{{ github.cuoi }}</b-tag>
              <b-tag v-else-if="github.co_token" type="is-danger">{{ lang('Token lỗi') }} …{{ github.cuoi }}</b-tag>
              <b-tag v-else type="is-warning">{{ lang('Chưa có token') }}</b-tag>
              <span v-if="github.hop_le" class="cn-phu">
                {{ lang('Giới hạn') }} {{ github.gioi_han }}/{{ lang('giờ') }} · {{ lang('còn') }} <b>{{ github.con_lai }}</b>
                · {{ lang('đặt lại lúc') }} {{ gioDatLai }}
              </span>
              <span v-else class="cn-gh-loi">{{ github.loi }}</span>
            </div>

            <form class="cn-gh-form" autocomplete="off" @submit.prevent="luuToken">
              <b-field :label="github && github.co_token ? lang('Thay bằng token khác') : lang('Dán token vào đây')">
                <b-input v-model="tokenNhap" type="password" password-reveal autocomplete="new-password" placeholder="github_pat_..." />
              </b-field>
              <div class="cn-gh-nut">
                <button type="submit" class="button is-primary is-small" :class="{ 'is-loading': dangGithub }" :disabled="dangGithub || !tokenNhap.trim()">{{ lang('Lưu và kiểm tra') }}</button>
                <button v-if="github && github.co_token" type="button" class="button is-small" :disabled="dangGithub" @click="goToken">{{ lang('Gỡ token') }}</button>
              </div>
              <p class="cn-phu">{{ lang('Token được lưu riêng trên máy chủ, không hiển thị lại và không gửi đi đâu ngoài GitHub.') }}</p>
            </form>

            <details class="cn-gh-huongdan">
              <summary>{{ lang('Cách tạo token (khoảng 1 phút)') }}</summary>
              <ol>
                <li>{{ lang('Đăng nhập GitHub (tài khoản miễn phí), mở') }}
                  <a href="https://github.com/settings/personal-access-tokens/new" target="_blank" rel="noopener">github.com/settings/personal-access-tokens/new</a></li>
                <li>{{ lang('Token name: đặt tên bất kỳ, ví dụ') }} <code>qldl-tim-ban-moi</code>. {{ lang('Expiration: chọn 1 năm (hết hạn thì tạo lại).') }}</li>
                <li>{{ lang('Repository access: giữ mặc định') }} <b>Public repositories (read-only)</b>. {{ lang('Không cần tích thêm quyền nào.') }}</li>
                <li>{{ lang('Bấm') }} <b>Generate token</b>, {{ lang('sao chép chuỗi bắt đầu bằng') }} <code>github_pat_</code> {{ lang('(chỉ hiện một lần) rồi dán vào ô phía trên.') }}</li>
              </ol>
              <p class="cn-phu">{{ lang('Hoặc dùng token kiểu cũ (classic) tại') }}
                <a href="https://github.com/settings/tokens/new" target="_blank" rel="noopener">github.com/settings/tokens/new</a>
                {{ lang('— không tích quyền nào, chỉ đặt tên và thời hạn.') }}</p>
            </details>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Menu from './partials/Menu'
import TheoDoiDialog from './partials/TheoDoiDialog'
import ChoXuLy from './partials/ChoXuLy'
import api from '../api/api'

export default {
  name: 'CapNhat',
  components: { Menu, ChoXuLy },
  data() {
    return {
      tab: 0,
      dangKiemTra: false,
      lichSu: [],
      locApp: '',
      chiLoi: false,
      thungRac: [],
      github: null,
      chonRac: [],
      dangXoa: false,
      tokenNhap: '',
      dangGithub: false,
      hen: null,
    }
  },
  computed: {
    gioDatLai() {
      if (!this.github || !this.github.dat_lai_luc) return ''
      const d = new Date(this.github.dat_lai_luc * 1000)
      return (d.getHours() < 10 ? '0' : '') + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
    },
    quyTac() {
      return this.$store.state.capNhat.quyTac
    },
    tongRac() {
      return this.thungRac.reduce((t, x) => t + (x.dung_luong || 0), 0)
    },
    // Co ban moi / dang tai len dau, roi den muc loi, con lai phia sau; trong moi nhom thi muc moi
    // them hoac moi cap nhat xong (gan day nhat) dung truoc.
    quyTacSapXep() {
      const uuTien = q => (q.trang_thai === 'moi' || q.trang_thai === 'dang_tai' ? 0 : q.trang_thai === 'loi' ? 1 : 2)
      const ganDay = q => Math.max(q.tao_luc || 0, q.tai && q.tai.trang_thai === 'xong' ? q.tai.cap_nhat_luc || 0 : 0)
      return this.quyTac.slice().sort((a, b) => uuTien(a) - uuTien(b) || ganDay(b) - ganDay(a))
    },
    soMoi() {
      return this.$store.state.capNhat.soMoi
    },
    dsApp() {
      const ten = new Set(this.quyTac.map(q => q.ung_dung))
      this.lichSu.forEach(x => ten.add(x.app))
      return Array.from(ten).filter(a => a && a !== 'Tất cả').sort()
    },
  },
  mounted() {
    const q = this.$route.query
    if (q.app) this.locApp = q.app
    if (q.tab === 'lichsu') this.tab = 1
    this.taiCapNhat()
    this.taiLichSu()
    this.taiThungRac()
    this.taiGithub()
    // Dang tai thi lam moi tien do moi 3 giay
    this.hen = setInterval(() => {
      if (this.quyTac.some(x => x.trang_thai === 'dang_tai')) {
        this.taiCapNhat().then(() => { this.taiLichSu(); this.taiThungRac() })
      }
    }, 3000)
  },
  beforeDestroy() {
    clearInterval(this.hen)
  },
  methods: {
    tag(q) {
      return this.tagCapNhat(q)
    },
    loaiTag(k) {
      return { a: 'is-info', s: 'is-success', w: 'is-warning', d: 'is-danger' }[k] || 'is-light'
    },
    doiTab(i) {
      if (i === 1) this.taiLichSu()
      if (i === 2) this.taiThungRac()
      if (i === 3) this.taiGithub()
    },
    taiLichSu() {
      api.capNhatLichSu({ app: this.locApp, loi: this.chiLoi ? 1 : 0 })
        .then(ds => { this.lichSu = Array.isArray(ds) ? ds : [] })
        .catch(error => this.handleError(error))
    },
    taiGithub() {
      api.capNhatGithub()
        .then(tt => { this.github = tt && typeof tt === 'object' ? tt : null })
        .catch(error => this.handleError(error))
    },
    luuToken() {
      this.dangGithub = true
      api.capNhatGithubDat({ token: this.tokenNhap.trim() })
        .then(tt => {
          this.dangGithub = false
          this.tokenNhap = ''
          this.github = tt
          this.$toast.open({ message: this.lang('Đã lưu token. Giới hạn tra cứu hiện là') + ' ' + tt.gioi_han + '/' + this.lang('giờ'), type: 'is-success' })
        })
        .catch(error => {
          this.dangGithub = false
          this.handleError(error)
        })
    },
    goToken() {
      this.$dialog.confirm({
        message: this.lang('Gỡ token GitHub? Giới hạn tra cứu sẽ về 60 lượt/giờ.'),
        confirmText: this.lang('Gỡ token'),
        cancelText: this.lang('Cancel'),
        type: 'is-danger',
        onConfirm: () => {
          api.capNhatGithubXoa()
            .then(tt => { this.github = tt })
            .catch(error => this.handleError(error))
        },
      })
    },
    taiThungRac() {
      api.capNhatThungRac()
        .then(ds => {
          this.thungRac = Array.isArray(ds) ? ds : []
          // Bo chon cac muc khong con trong thung rac
          this.chonRac = this.chonRac.filter(c => this.thungRac.some(x => x.id === c.id))
        })
        .catch(error => this.handleError(error))
    },
    kiemTraTatCa() {
      this.dangKiemTra = true
      api.capNhatKiemTra({})
        .then(tk => {
          this.dangKiemTra = false
          this.$toast.open({
            message: this.lang('Kiểm tra xong') + ': ' + tk.co_ban_moi + ' ' + this.lang('phần mềm có bản mới') + (tk.loi ? ', ' + tk.loi + ' ' + this.lang('lỗi') : ''),
            type: tk.loi ? 'is-warning' : 'is-success',
          })
          this.taiCapNhat()
          this.taiLichSu()
        })
        .catch(error => {
          this.dangKiemTra = false
          this.handleError(error)
        })
    },
    taiBanMoi(q) {
      api.capNhatTai({ id: q.id })
        .then(() => {
          this.$toast.open({ message: this.lang('Đã bắt đầu tải') + ' ' + q.ung_dung + ' ' + q.moi_nhat, type: 'is-success' })
          // Doi may chu kip ghi trang thai "dang tai" roi moi lam moi
          setTimeout(() => { this.taiCapNhat() }, 1200)
        })
        .catch(error => this.handleError(error))
    },
    sua(q) {
      this.$modal.open({
        parent: this,
        hasModalCard: true,
        component: TheoDoiDialog,
        props: { quyTac: q },
        events: { saved: () => { this.taiCapNhat(); this.taiLichSu() } },
      })
    },
    huy(q) {
      this.$dialog.confirm({
        message: this.lang('Hủy theo dõi') + ' ' + q.ung_dung + '? ' + this.lang('File không bị xóa, lịch sử vẫn được giữ.'),
        type: 'is-danger',
        cancelText: this.lang('Cancel'),
        confirmText: this.lang('Hủy theo dõi'),
        onConfirm: () => {
          api.capNhatBo({ id: q.id })
            .then(() => {
              this.$toast.open({ message: this.lang('Đã hủy theo dõi'), type: 'is-success' })
              this.taiCapNhat()
              this.taiLichSu()
            })
            .catch(error => this.handleError(error))
        },
      })
    },
    khoiPhuc(x) {
      api.capNhatKhoiPhuc({ id: x.id })
        .then(() => {
          this.$toast.open({ message: this.lang('Đã khôi phục') + ' ' + x.ten, type: 'is-success' })
          this.taiThungRac()
          this.taiLichSu()
        })
        .catch(error => this.handleError(error))
    },
    xoaNhieu(thamSo) {
      this.dangXoa = true
      api.capNhatXoaHan(thamSo)
        .then(kq => {
          this.dangXoa = false
          this.chonRac = []
          this.$toast.open({
            message: this.lang('Đã xóa hẳn') + ' ' + kq.da_xoa + ' ' + this.lang('tệp') + ' (' + this.formatBytes(kq.giai_phong) + ')' + (kq.loi ? ', ' + kq.loi + ' ' + this.lang('lỗi') : ''),
            type: kq.loi ? 'is-warning' : 'is-success',
          })
          this.taiThungRac()
          this.taiLichSu()
        })
        .catch(error => {
          this.dangXoa = false
          this.handleError(error)
        })
    },
    xoaDaChon() {
      const ds = this.chonRac.slice()
      const dl = ds.reduce((t, x) => t + (x.dung_luong || 0), 0)
      this.$dialog.confirm({
        message: this.lang('Xóa hẳn') + ' <b>' + ds.length + '</b> ' + this.lang('tệp đã chọn') + ' (' + this.formatBytes(dl) + ')? ' + this.lang('Không khôi phục lại được.'),
        type: 'is-danger',
        hasIcon: true,
        cancelText: this.lang('Cancel'),
        confirmText: this.lang('Xóa hẳn'),
        onConfirm: () => this.xoaNhieu({ ids: ds.map(x => x.id) }),
      })
    },
    xoaToanBo() {
      this.$dialog.confirm({
        title: this.lang('Xóa toàn bộ thùng rác'),
        message: this.lang('Xóa hẳn') + ' <b>' + this.thungRac.length + '</b> ' + this.lang('tệp trong thùng rác') + ' (' + this.formatBytes(this.tongRac) + ')? ' + this.lang('Không khôi phục lại được.'),
        type: 'is-danger',
        hasIcon: true,
        cancelText: this.lang('Cancel'),
        confirmText: this.lang('Xóa toàn bộ'),
        onConfirm: () => this.xoaNhieu({ tat_ca: true }),
      })
    },
    xoaHan(x) {
      this.$dialog.confirm({
        message: this.lang('Xóa hẳn') + ' ' + x.ten + '? ' + this.lang('Không khôi phục lại được.'),
        type: 'is-danger',
        cancelText: this.lang('Cancel'),
        confirmText: this.lang('Xóa hẳn'),
        onConfirm: () => {
          api.capNhatXoaHan({ id: x.id })
            .then(() => {
              this.taiThungRac()
              this.taiLichSu()
            })
            .catch(error => this.handleError(error))
        },
      })
    },
  },
}
</script>

<style scoped>
#capnhat-page { margin-top: 1.2rem; }
.cn-dau { align-items: center; margin-bottom: 0.8rem; }
.cn-ten { font-weight: 600; }
.cn-phu { font-size: 0.8rem; opacity: 0.65; word-break: break-all; }
.cn-hanhdong { display: flex; gap: 0.4rem; justify-content: flex-end; white-space: nowrap; }
.cn-loc { align-items: center; gap: 1rem; margin-bottom: 0.8rem; }
.cn-chitiet { font-size: 0.85rem; opacity: 0.85; }
.cn-rong { padding: 1rem 0; opacity: 0.7; }
.cn-ghichu { margin-top: 0.8rem; }
.cn-cd { max-width: 640px; padding: 0.4rem 0; display: flex; flex-direction: column; gap: 0.75rem; }
.cn-cd-tieu { font-size: 1.05rem; font-weight: 600; }
.cn-gh-tt { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
.cn-gh-loi { color: #e0245e; font-size: 0.85rem; }
.cn-gh-nut { display: flex; gap: 0.5rem; margin-bottom: 0.4rem; }
.cn-gh-huongdan { font-size: 0.88rem; background: rgba(127, 140, 160, 0.1); border-radius: 8px; padding: 0.6rem 0.9rem; }
.cn-gh-huongdan summary { cursor: pointer; font-weight: 600; }
.cn-gh-huongdan ol { margin: 0.5rem 0 0.4rem 1.2rem; display: flex; flex-direction: column; gap: 0.3rem; }
.cn-gh-canh a { margin-left: 0.4rem; font-weight: 600; cursor: pointer; }
.cn-rac-nut { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; margin-bottom: 0.6rem; }
</style>
